module.exports = __webpack_public_path__ + "static/media/rem-galleu-lose.cb6ac37f.png";